import http from '../util/request.js'

export const doLogin = (params) =>{
	return http({
		url:'/api/token/login',
		data:params,
		method:'post'
	})
}
export const doRegister = (params) =>{
	return http({
		url:'/api/token/register',
		data:params,
		method:'post'
	})
}
export const queryProductPage = (params) =>{
	return http({
		url:'/api/product/intodata',
		data:params,
		method:'get'
	})
}
export const queryProductInfo = (params) =>{
	return http({
		url:'/api/product/dtl',
		data:params,
		method:'get'
	})
}
export const initHome = (params) =>{
	return http({
		url:'/api/home/homeinto',
		data:params,
		method:'get'
	})
}
export const initHeader = (params) =>{
	return http({
		url:'/api/home/hometitle',
		data:params,
		method:'get'
	})
}
export const queryCartQty = (params) =>{
	return http({
		url:'/api/cartadvanced/querycartqty',
		data:params,
		method:'get'
	})
}
export const logout = (params) =>{
	return http({
		url:'/api/member/logout',
		data:params,
		method:'post'
	})
}
export const initHomeProduct = (params) =>{
	return http({
		url:'/api/home/homeintoproduct',
		data:params,
		method:'get'
	})
}
export const getAddressList = (params) =>{
	return http({
		url:'/api/memberAddress/list',
		data:params,
		method:'get'
	})
}
export const uploadFile = (params) =>{
	return http({
		url:'/api/file/upload',
		data:params,
		method:'post',
		config:'formData'
	})
}
export const queryorderprocess = (params) =>{
	return http({
		url:'/api/product/queryorderprocess',
		data:params,
		method:'get'
	})
}
export const addCart = (params) =>{
	return http({
		url:'/api/cartadvanced/add',
		data:params,
		method:'post',
		config:'json'
	})
}
export const getCartList = (params) =>{
	return http({
		url:'/api/cartadvanced/list',
		data:params,
		method:'get'
	})
}
export const queryRegion = (params) =>{
	return http({
		url:'/api/memberAddress/queryregion',
		data:params,
		method:'get'
	})
}
export const addAddress = (params) =>{
	return http({
		url:'/api/memberAddress/add',
		data:params,
		method:'post'
	})
}
export const editAddress = (params) =>{
	return http({
		url:'/api/memberAddress/updateMemberAddress',
		data:params,
		method:'post'
	})
}
export const delCart = (params) =>{
	return http({
		url:'/api/cartadvanced/del',
		data:params,
		method:'post'
	})
}
export const initConfirmOrder = (params) =>{
	return http({
		url:'/api/order/toOrder',
		data:params,
		method:'get'
	})
}
export const editCartNum = (params) =>{
	return http({
		url:'/api/cartadvanced/edit',
		data:params,
		method:'post'
	})
}
export const commentList = (params) =>{
	return http({
		url:'/api/orderprocess/list',
		data:params,
		method:'get'
	})
}
export const createOrder = (params) =>{
	return http({
		url:'/api/order/createOrder',
		data:params,
		method:'post',
		config:'json'
	})
}
export const queryOrderList = (params) =>{
	return http({
		url:'/api/order/queryOrderList',
		data:params,
		method:'get'
	})
}
export const printingKnowledgelist = (params) =>{
	return http({
		url:'/api/printingKnowledge/printingknowledgelist',
		data:params,
		method:'get'
	})
}
export const queryPrintingKnowledge = (params) =>{
	return http({
		url:'/api/printingKnowledge/queryprintingknowledgelist',
		data:params,
		method:'get'
	})
}
export const queryPrintingKnowledgeInfos = (params) =>{
	return http({
		url:'/api/printingKnowledge/queryPrintingKnowledgeContentDtl',
		data:params,
		method:'get'
	})
}
export const searchProductByName = (params) =>{
	return http({
		url:'/api/product/querylist',
		data:params,
		method:'get'
	})
}
export const designservicecontent = (params) =>{
	return http({
		url:'/api/printingKnowledge/designservicecontent',
		data:params,
		method:'get'
	})
}
export const createPaymentntent = (params) =>{
	return http({
		url:'/api/pay/create-payment-intent/',
		data:params,
		method:'post'
	})
}
export const tocartcreatepaymentintent = (params) =>{
	return http({
		url:'/api/pay/tocartcreatepaymentintent',
		data:params,
		method:'post'
	})
}
export const confirmQuotes = (params) =>{
	return http({
		url:'/api/quotation/add',
		data:params,
		method:'post',
		config:'json'
	})
}
export const updatePwd = (params) =>{
	return http({
		url:'/api/member/updatepws',
		data:params,
		method:'post'
	})
}
export const brandList = (params) =>{
	return http({
		url:'/api/activity/getActivityList',
		data:params,
		method:'get'
	})
}
export const updateAccount = (params) =>{
	return http({
		url:'/api/member/updateaccount',
		data:params,
		method:'post'
	})
}
export const getAccountInfos = (params) =>{
	return http({
		url:'/api/member/edit-account',
		data:params,
		method:'get'
	})
}
export const getArticle = (params) =>{
	return http({
		url:'/api/printingKnowledge/queryarticle',
		data:params,
		method:'get'
	})
}
export const confrimContactUs = (params) =>{
	return http({
		url:'/api/member/addSuggestion',
		data:params,
		method:'post',
		config:'json'
	})
}
export const getOrderDetail = (params) =>{
	return http({
		url:'/api/order/getOrderDtl',
		data:params,
		method:'get'
	})
}
export const forgotPassword = (params) =>{
	return http({
		url:'/api/member/forgotpassword',
		data:params,
		method:'post'
	})
}
export const resetPassword = (params) =>{
	return http({
		url:'/api/member/newpassword',
		data:params,
		method:'post'
	})
}